import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { RepairPartSearchTextForm } from '../../../form-model/repair-part-search-text.form.model';

@Component({
  selector: 'app-repair-part-search',
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './repair-part-search.component.html',
  styleUrl: './repair-part-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairPartSearchComponent implements OnInit {
  @Input({ required: true }) repairPartSearchTextForm!: FormGroup<RepairPartSearchTextForm>;

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit() {
    this.addControlsToTheFormGroup();
  }

  applySearchTextFilters() {
    this.repairPartSearchTextForm.controls.appliedRepairPartSearchTextFilter.setValue(true);
  }

  isControlInErrorState(control: FormControl): boolean | null {
    if (control.invalid && control.touched) {
      return true;
    }
    return null;
  }

  private addControlsToTheFormGroup() {
    if (!this.repairPartSearchTextForm.get('SearchText')) {
      this.repairPartSearchTextForm.addControl('SearchText', this.formBuilder.control<string | null>(null));
    }
    if (!this.repairPartSearchTextForm.get('appliedRepairPartSearchTextFilter')) {
      this.repairPartSearchTextForm.addControl('appliedRepairPartSearchTextFilter', this.formBuilder.control<boolean | null>(null));
    }
  }
}
